import { Swiper as SliderContainer, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// @interfaces
import styles from '../styles/pages/estimation/EntryPage.module.css';
import "swiper/css";
import "swiper/css/pagination";
import { IEntryPageConfiguration } from "../merchantConfig";
import Button from "./Button";
import {useMediaQuery} from "react-responsive";
import {useState} from "react";

interface ContributionOptionsProps {
  config: IEntryPageConfiguration;
  setCurrency: (currency: string) => void;
  setOffsetAmount: (amount: number) => void;
  setEntryOptionSelected: (entryOptionSelected: boolean) => void;
  merchantCode: string;
  makeQuote: (amount: number, currency: string, merchantCode: string) => void;
}

const ContributionOptions: React.FC<ContributionOptionsProps> = ({ config, setCurrency, setOffsetAmount, merchantCode, setEntryOptionSelected, makeQuote }) => {

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const isMobile = useMediaQuery({ query: "(max-width: 400px)" });

  const handleOptionClick = (value: number) => {
    if(config.currency) {
      setOffsetAmount(value);
      setCurrency(config.currency);
      makeQuote(value, config.currency, merchantCode);
      setEntryOptionSelected(true);
    }
  }

  return (
    <SliderContainer
      modules={[Pagination]}
      pagination={{ clickable: true }}
      onSlideChange={(swiper) => {
        console.log(swiper.activeIndex);
        setActiveIndex(swiper.activeIndex);
      }}
      initialSlide={1}
      spaceBetween={isMobile ? 5 : 10}
      centeredSlides={Boolean(config.options?.length && config.options?.length > 2)}
      slidesPerView={(isMobile || config.options?.length === 1) ? 1.5 : 2}
      className={styles.carouselContainer}
    >
      {config.options?.map((option: any, index: number) => {
        return (
          <SwiperSlide
            className={styles.carouselItem}
            style={{opacity: (index - activeIndex < -1 || index - activeIndex > 1) ? 0 : 1}}
            key={index}
          >
            <div
              className={styles.carouselImg}
            >
              <div>
                <p className={styles.optionName}>{option.title}</p>
                <p className={styles.optionDescription}>{option.description}</p>
              </div>
              <div className={styles.optionButtonContainer}>
                <Button
                    variant={"secondary"}
                    text={'Select'}
                    onClick={() => {handleOptionClick(option.value)}}
                />
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </SliderContainer>
  )
};

export default ContributionOptions;
